import axios from 'axios';
import VueCookies from 'vue-cookies';
import store from './store/store';

const instance = axios.create({
  baseURL: process.env.VUE_APP_API,
});

const reqinterceptor = instance.interceptors.request.use((req) => {
  const token = $cookies.get('user_api_token');

  if (token && !req.baseURL.includes('auth/token') && !req.url.includes('checkout.com')) {
    req.headers.authorization = `bearer ${token}`;
  }
  return req;
});

const resInterceptor = instance.interceptors.response.use((response) => response, (error) => {
  const status = error.response ? error.response.status : null;

  console.log(status);
  if (status === 401) {
    console.log('user not authorized - log user out');
    store.dispatch('users/logOut');
  }

  return Promise.reject(error);
});

export default instance;
